import { BattleResult, IngameMode } from '@profile/src/models';
export const formatResult = result => {
  switch (result) {
    case BattleResult.VICTORY:
      {
        return 'Victory';
      }

    case BattleResult.LOSE:
      {
        return 'Lose';
      }

    case BattleResult.DRAW:
      {
        return 'Draw';
      }

    default:
      return '';
  }
};
export const formatGameMode = mode => {
  switch (mode) {
    case IngameMode.TEAM_COLLECT_STAR:
      {
        return 'Team Collect Star';
      }

    case IngameMode.SOLO_SURVIVAL:
      {
        return 'Battle Royale Solo';
      }

    case IngameMode.DUAL_SURVIVAL:
      {
        return 'Battle Royale Duo';
      }

    case IngameMode.TEAM_COLLECT_STAR_4_VS_4:
      {
        return 'Super Star';
      }

    case IngameMode.KING:
      {
        return 'King';
      }

    case IngameMode.DEATH_MATCH:
      {
        return 'Death Match';
      }

    case IngameMode.DEATH_MATCH_3_VS_3:
      {
        return 'Death Match 3vs3';
      }

    case IngameMode.FLAG:
      {
        return 'Flag';
      }

    case IngameMode.TOWER:
      {
        return 'Tower';
      }

    case IngameMode.TRY_HERO_SKILL_MODE:
      {
        return 'Try Mode';
      }

    case IngameMode.NONE:
      {
        return 'None';
      }

    case IngameMode.TUTORIAL:
      {
        return 'Tutorial';
      }

    default:
      {
        return 'Undefined';
      }
  }
};